import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  ContentProvider,
  PageContainer,
  PageHeader,
  PageLead,
} from '../content/components';
import { ContentSection } from '../layout/components';

import {
  CrossLinksSection,
  OpenPositionsBlock,
  TidBits,
  SectionHeader,
} from './components';

import {
  BleedSectionLandscapeLeft,
  BleedSectionPortraitRight,
} from './components/sections';

class CareersPage extends Component {
  static propTypes = {
    breakpoint: PropTypes.string.isRequired,
  };

  render() {
    const { breakpoint } = this.props;
    return (
      <ContentProvider
        slug="careers"
        render={({
          header,
          intro,
          open_positions,
          primary,
          secondary,
          cross_links,
          wacky_facts_title,
          wacky_facts,
        }) => (
          <PageContainer>
            <PageHeader
              title={header.title}
              subtitle={header.subtitle}
              mainImage={header.main_image}
            />
            <PageLead
              title={intro.blurb}
              content={intro.content}
              links={intro.links}
              supportImage={
                header.support_media_format === 'circular'
                  ? header.support_image_circular
                  : header.support_image_portrait
              }
              supportVideo={header.support_video}
              supportMediaType={header.support_media_type}
              supportIsCircular={header.support_media_format === 'circular'}
            />

            <ContentSection title="Current Positions">
              {open_positions.terms.map(category => (
                <OpenPositionsBlock
                  key={category.slug}
                  category={category.title}
                  slug={category.slug}
                  numPositions={category.count}
                  totalPositions={open_positions.total}
                  linkTo={`/careers/${category.slug}`}
                />
              ))}
            </ContentSection>

            <SectionHeader title="Do you want a key role on a gaming journey-of-a-lifetime?" />

            <BleedSectionLandscapeLeft
              breakpoint={breakpoint}
              subTitle={primary.subtitle}
              title={primary.title}
              mainImage={primary.main_image}
              supportImage={primary.support_image}
              supportVideo={primary.support_video}
              supportMediaType={primary.support_media_type}
              renderContent={() => (
                <div dangerouslySetInnerHTML={{ __html: primary.content }} />
              )}
              links={primary.links}
            />

            <BleedSectionPortraitRight
              breakpoint={breakpoint}
              subTitle={secondary.subtitle}
              title={secondary.title}
              mainImage={secondary.main_image}
              supportImage={secondary.support_image}
              supportVideo={secondary.support_video}
              supportMediaType={secondary.support_media_type}
              renderContent={() => (
                <div dangerouslySetInnerHTML={{ __html: secondary.content }} />
              )}
              links={secondary.links}
            />

            {wacky_facts_title &&
              wacky_facts && (
                <TidBits title={wacky_facts_title} facts={wacky_facts} range />
              )}

            {cross_links && <CrossLinksSection crossLinks={cross_links} />}
          </PageContainer>
        )}
      />
    );
  }
}

const mapStateToProps = state => {
  const { breakpoint } = state.layout;
  return {
    breakpoint,
  };
};

export default connect(mapStateToProps, null)(CareersPage);



// WEBPACK FOOTER //
// ./src/modules/pages/CareersPage.js